// extracted by mini-css-extract-plugin
module.exports = {"home-section-container":"Homepage_home-section-container__lu7zY","home-section-container__remove-padding":"Homepage_home-section-container__remove-padding__EzENB"};